// @ts-nocheck
import { type GlobalElementsProps } from '../lib/types'

function GlobalHeader({ html }: GlobalElementsProps) {
  return <header id="ge-header" dangerouslySetInnerHTML={{ __html: html ?? '' }} />
}

export default GlobalHeader
